import { AIEngine } from '../assistant/AIEngine'
import type { IAssistantProvider } from './IAssistantProvider'
import type { AIConfig } from '../types'

/**
 * Local deterministic provider — no external LLM calls in this sprint.
 */
export class LocalAssistantProvider implements IAssistantProvider {
  private engine: AIEngine

  constructor(config: Partial<AIConfig> = {}) {
    this.engine = new AIEngine(config)
  }

  setConfig(config: Partial<AIConfig>) {
    return this.engine.setConfig(config)
  }

  getConfig() {
    return this.engine.getConfig()
  }

  analyzeQuote(...args: Parameters<IAssistantProvider['analyzeQuote']>) {
    return this.engine.analyzeQuote(...args)
  }

  analyzePurchase(...args: Parameters<IAssistantProvider['analyzePurchase']>) {
    return this.engine.analyzePurchase(...args)
  }

  recommendSupplier(...args: Parameters<IAssistantProvider['recommendSupplier']>) {
    return this.engine.recommendSupplier(...args)
  }

  recommendPrice(...args: Parameters<IAssistantProvider['recommendPrice']>) {
    return this.engine.recommendPrice(...args)
  }

  generateDescription(...args: Parameters<IAssistantProvider['generateDescription']>) {
    return this.engine.generateDescription(...args)
  }

  summarize(...args: Parameters<IAssistantProvider['summarize']>) {
    return this.engine.summarize(...args)
  }

  generateInsights(...args: Parameters<IAssistantProvider['generateInsights']>) {
    return this.engine.generateInsights(...args)
  }

  generateObservations(...args: Parameters<NonNullable<IAssistantProvider['generateObservations']>>) {
    return this.engine.generateObservations(...args)
  }
}

export const localAssistantProvider = new LocalAssistantProvider()
